import CheckboxSelectAllController from './checkbox_select_all_controller';

export default class PushNotificationPreferenceSelectAllController extends CheckboxSelectAllController {}
